export enum NotificationTypes {
  Информация = 'LINK_TO_INFO_VOLUNTEERNOTE',
  Просьба = 'LINK_TO_APPLICATION_CARD',
  Список_Просьб = 'LINK_TO_APPLICATION_LIST',
}
